var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"width-100"},[_c('h2',{staticClass:"section-title"},[_vm._v(_vm._s(_vm.$t('thermostats.title')))]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }